import styled from 'styled-components';

export const CustomError = styled.span`
color: #f44336;
margin-left: 14px;
margin-top: 4px;
font-size: 0.75rem;
`;
